<template>
  <div class="inventoryRp">
      <div class="desc">
          <div class="titleDesc">{{$t('other.a1889')}}</div>
         <!-- <div class="remindData">
             <div>
                <span class="store">{{stockReminder}}{{$t('other.a707')}}</span>
                
             </div>
             <div>
                 <div class="btn">
                    仓库帐号查询：<el-input size="medium" style="width:350px;margin:0 5px;" v-model="orderId" :placeholder="$t('other.a764')"></el-input>
                </div>
             </div>
         </div> -->
      </div>
      <div>
          <el-table 
            :data="logsList"
            ref="multipleTable"
            border>
                <el-table-column :label="$t('other.a1890')"  :show-overflow-tooltip="true">
                    <template scope="scope" >
                        <span>{{scope.row.storeName}}</span>
                        <!-- <span>{{scope.row.payType}}</span> -->
                    </template>
                </el-table-column >
                <el-table-column :label="$t('other.a1891')"  :show-overflow-tooltip="true">
                    <template scope="scope" >
                        <span>{{scope.row.storeId}}</span>
                    </template>
                </el-table-column >
                <el-table-column :label="$t('other.a1892')"   :show-overflow-tooltip="true">
                    <template scope="scope" >
                        <span>{{storeTypeNum[scope.row.storeType]}}</span>
                    </template>
                </el-table-column >
                 <el-table-column :label="$t('other.a269')"   prop="storeAddress" :show-overflow-tooltip="true">
                    <template scope="scope" >
                        <span>{{showCountryName(scope.row.storeAddress)}}</span>
                    </template>
                </el-table-column >  

                <el-table-column :label="$t('other.a89')"   prop="createTime" :show-overflow-tooltip="true">
                    <template scope="scope" >
                        <span>{{scope.row.createTime}}</span>
                    </template>
                </el-table-column >    
               
				</el-table>

             <div class="pagination">

                 <el-pagination
                background
                size="mini"
                @current-change="handleCurrentChange"
                layout="prev, pager, next"
                :total="stockReminder">
                </el-pagination>
             </div>       
      </div>
  </div>
</template>

<script>
import utils from '../../utils/utils'
import deductionApi from '../../api/moudles/deduction'
import userStoreItems from '../../api/moudles/userStoreItems'
import * as echarts from 'echarts';
import { mapState, mapActions, mapMutations} from 'vuex'
export default {
data(){
return{
    sellerList:[],
    page:0,
    stockReminder:0,
    orderId:null,
    storeTypeNum:[this.$t('other.a1893'),this.$t('other.a1894'),this.$t('other.a1895'),this.$t('other.a1896'),this.$t('other.a1897')],


}
},
computed:{

    logsList(){
        let list=JSON.parse(JSON.stringify(this.sellerList))
        let page=this.page
        this.stockReminder=list.length

        let list4=list.splice(page,10)

        console.log('list4',list4)
        return list4

    },

},
created(){
    this.sellerList=JSON.parse(localStorage.getItem('userInfo')).stores
    this.sellerList.forEach(p => {
      p.createTime=utils.renderTime(p.createTime)
    })
    this.sellerList.sort((a,b) => {
      return b.createTime - a.createTime > 0
    })
    console.log('sellerList',this.sellerList)

},
methods:{

    ...mapActions('userStoreItems', [
        'getStockRemind',
    ]),



    

    getPointLog(){
        deductionApi
        .getIntegralLog(this.logparams)
        .then(res => {
            if(res.code === 200) {
                console.log('收入支出',res.data.logs)
                
                let listCopy=res.data.logs.filter(p => {
                    p.sellerUserId=p.sellerUserId == "0"  ? p.payWith :p.sellerUserId
                    if(utils.logFilterByPayType(p.payType,'STORE')){
                        return p
                    }
                })

                this.updataFeeBtn(listCopy)

                console.log(';listCopy',listCopy)
                listCopy.forEach(p => {
                    p.createTime=utils.getCurrnetTime(p.createTime)
                    p.logDesc=null
                    if(p.orderDeductions){
                        p.logDesc=p.orderDeductions.map(p => {
                            return  Math.abs(p.orderFee.toFixed(2) )+ "积分--" +p.desc
                        })
                    }
                })
                this.orderList=listCopy
                
               

                
            }else{
                this.$message.warning(res.msg)
            }
        })
    },

    showChange(id){
        
        let ttp=this.payTypeOptions.find(item => item.value == id)
        if(ttp){
            return ttp.label
        }else{
            return id
        }
    },

    showSellerName(id){
        let ttp=this.allseller.find(item => item.userId == id)
        if(ttp){
            return ttp.userName
        }else{
            return id
        }
    },

    exportXlm(){
        this.showLoading()
        let that=this
        let obj=JSON.parse(JSON.stringify(this.logparams))
        obj.offset=this.stockReminder+5
        deductionApi
        .getIntegralLog(obj)
        .then(res => {
            if(res.code === 200) {
                console.log('收入支出',res.data)
                let list=res.data.logs
                let arr=[]
                list.forEach(p => {
                    p.createTime=utils.getCurrnetTime(p.createTime)
                    p.desc=[]
                    p.orderDeductions.forEach(i => {
                         p.desc.push('/' +i.orderFee + '积分，' + i.desc + '/')
                    })
                    arr.push({
                        '费用类型':that.showChange(p.payType),
                        '订单号':p.payOrderId,
                        '积分变化':p.changeIntegral,
                        '可用积分':p.newIntegral,
                        '支付来源':that.showSellerName(p.payWith),
                        '时间':p.createTime,
                        '扣减明细':p.desc.join('&'),
                        
                    })
                })
                console.log('arr',arr)

                let list2=['费用类型','订单号','积分变化','可用积分','支付来源','时间','扣减明细']

                utils.exPortEXml(arr,list2,list2)
                console.log('list',list)
              
            }else{
                this.$message.warning(res.msg)
            }
        })


       
    },

    changeSort(val){
        console.log('jkdfn',val)
         if(this.type == 0){
            let list=JSON.parse(JSON.stringify(this.remindData))

             this.sortOrderData(list,val.order,val.prop)
            
        }else if(this.type == 1){
            let list=JSON.parse(JSON.stringify(this.outOfstockReminder))
            this.sortOrderData(list,val.order,val.prop)
            
        }else{
            let list=JSON.parse(JSON.stringify(this.unsalable))
            this.sortOrderData(list,val.order,val.prop)
        }
    },

    sortOrderData(arr,order=null,type){
        let list=arr
        if(order == 'ascending'){
            arr.sort((a,b) => {
                return a[type]-b[type]
            })
        }else if(order == 'descending'){
            arr.sort((a,b) => {
                return b[type]-a[type]
            })
        }

        if(this.type ==0 ){
            this.remindData=arr
        }else if(this.type == 1){
            this.outOfstockReminder=arr
        }else{
            this.unsalable=arr
        }
    },



    getTime(){
        console.log(this.value6)
        this.logparams.end=utils.CurdateAddoneday(this.value6[1])
        this.logparams.start=this.value6[0]
        this.getPointLog()
    },

    getDataOfType(num){
        
        this.dataOfType=Number(num)
        let list=[]
        let list2=[]

        for(let i=0;i<this.dataOfType;i++){
            list.unshift(utils.getRecentSevenDay(-i))
            list2.unshift(0)
        }

        this.value6=[list[0],list[list.length-1]]
        this.logparams.end=utils.CurdateAddoneday(this.value6[1])
        this.logparams.start=this.value6[0]
        this.getPointLog()
    },

    viewSales(item){
    console.log('item',item)
    this.dialogVisible=true
    this.mainItem=item
 
    },

    showCountryName(id){
        return utils.getCountryName(id)
    },

  
    getData(item,num){
        console.log('remindData',this.remindData)
        if(num == 0){
            this.storeId = item.value
            this.logparams.storeIds=item.value == 0 ? null : [item.value] 
        }else if(num == 1){
            this.sellerId=item.value
            this.logparams.sellerIds=item.value
           
        }else if(num == 2){
            this.pointType=item.value
            this.logparams.payType=item.value
        }
        
       
    },

    getRecharge(){
        this.logparams.payType=this.pay_Value
        this.getPointLog()
    },

    upataOutOfStack(data){
        console.log(data)
        let arr=this.remindData.filter(p => {
            p.dayOfShip=Number(data.dayOfShip)
            p.salesAvg01=Number(p.salesAvg.toFixed(2))
            p.needStock01= data.type ? p.dayOfShip*2*p.salesAvg01-p.nowStock-p.shippedStock : p.dayOfShip*2*p.salesAvg01-p.nowStock
            return p
        })
        let list = arr.filter(p => {
            if( p.storeItem.storeId == this.storeId && p.needStock01> 0){
                return p
            }
        })
        console.log('arr',arr)

        list.forEach(i => {
            i.needStock01=Math.ceil(i.needStock01)
            i.salesAvg01=Math.ceil(i.salesAvg01)
        })
        console.log('list',list)
        this.outOfstockReminder=list
        this.timeList[1].num=list.length 
    },

    handleCurrentChange(val){
        console.log(val)
        this.page=Number(val-1)*10
        
    },

    fuzzyMatch(str, key) {
        
       
        str == null ? '' : str
        if(typeof(str) == Number) {
            return str==key
        }

        console.log(typeof(key))

        if(typeof(key) == 'string' && str) {
            console.log(str,key,key.indexOf(str))
            let ttp=false
            if(key.indexOf(str) > -1 || str == key){
                ttp=true
            }
            return ttp
        }else {
            return false;
        }
        
       
    },

    getStockRemindCopy(){
				new Promise((resolve,reject) => {
        let that=this
				this.getStockRemind({userId:this.userId,storeId:this.storeId}).then(res => {
					console.log('852',res)
						if(res.code == 200) {
                            this.originRemindOrder=res.data
							this.remindData=res.data.filter(p => {
                                p.lastTime=p.lastTime ? utils.getCurrnetTime(p.lastTime) : this.$t("other.a354")
                                p.salesAvgMonthly=p.salesAvgMonthly.toFixed(2)
                                p.goodsValue=p.storeItem.storeNum*p.storeItem.cost
                                if(p.storeItem.storeId == this.storeId){
                                    return p
                                }
                            })

                            console.log('remindData',this.remindData)

							this.unsalable=this.remindData.filter(k => {
								if(k.unsalable){
									return k
								}
							})
                            this.timeList[0].num=this.remindData.length

							console.log('unsalable',this.unsalable)
                            this.timeList[2].num=this.unsalable.length
							let arr=this.remindData.filter(p => {
								p.salesAvg01=Number(p.salesAvg.toFixed(2))
								p.needStock01=p.dayOfShip*2*p.salesAvg01-p.nowStock
								return p
							})
                            console.log('arr',arr)
							let list = arr.filter(p => {
								if( p.storeItem.storeId == that.storeId && p.needStock01> 0){
									return p
								}
							})
                            console.log('list1112',list)
							resolve(list)
						}
					})
				}).then(res => {
					res.forEach(i => {
						i.needStock01=Math.ceil(i.needStock01)
						i.salesAvg01=Math.ceil(i.salesAvg01)
					})
					this.outOfstockReminderAmont=res.length
					this.outOfstockReminder=res
                    this.timeList[1].num=res.length
					console.log('缺货提醒11',res)
				})
			},

}
}

</script>
<style lang='scss' scoped>
.inventoryRp{
    background-color: white;
    margin: 20px 15px;
    padding: 10px;
    border-radius: 5px;

    .pong{
        display: flex;

        .okng{
            font-size: 14px;
            color: #919099;
            cursor: pointer;
            margin-left: 30px;
            margin-bottom: 15px;
            padding: 3px 10px;
            border-radius: 3px;
        }

        .active{
            background-color: #66b1ff;
            padding: 3px 10px;
            border-radius: 3px;
            color: #fff;
        }
    }

    .iknkg{
        width: 100%;
        height: 300px;
        display: flex;
        justify-content: center;
    }

    .remindData{
       display: flex;
       margin-top: 30px;
       justify-content: space-between;

        .btn{
            text-align: right;
            margin-bottom:10px;
            margin-right: 30px;
        }
    }

    .itemWrapper{
        display: flex;
        margin-bottom: 5px;
    }



    .sokng{
        display: inline-block;
        min-width: 70px;
        text-align: center;
        margin: 0 10px;
        cursor: pointer;
        color: #919099;
        padding: 3px ;
        margin: 3px 5px 10px 3px;
         
    }

    .store{
        
        margin-right:30px ;
        box-sizing: border-box;
        padding-top:5px;
        color: #919099;
        width: 120px;;
    }

    .uykpg{
        width: 90px;
        margin-left:30px ;
        margin-right:30px ;
        box-sizing: border-box;
        padding-top:5px;
        color: #0d79f5;
        cursor: pointer;
    }
    .desc{
        width: 100%;


        .titleDesc{
            font-weight: bold;
            color: #616066;
            margin-bottom:30px;
            padding:0px 10px;
            font-size: 25px;
            text-align: center;
        }

    }

    .active{
        color: #fff;
        background-color: #66b1ff;
        padding: 3px ;
        border-radius: 3px;
    }

    .pagination{
        text-align: right;
        margin-top: 18px;
        margin-right: 30 ;
    }

}
</style>